/* eslint-disable */
import { makeStyles } from "@material-ui/core/styles"

export const useStyles = makeStyles({
    snackBarStyle: {
      width: "100%",
      position: "absolute",
      height: "50px",
      top: "0",
      marginTop:'8px'
    },
     IconCustom: {
      fill: '#CC3D3F',
    },
    checkIconCustom: {
      backgroundColor: "#31806F",
      borderRadius: "50%",
      fill: 'white',
    },
    toastMessage: {
      fontFamily:'Work Sans',
      fontWeight: "normal",
      fontSize: "16px",
      lineHeight: "20px",
      width: "100%",
    },
    toastSuccessMessage: {
      width: "100%",
      backgroundColor: '#F4FAF8',
      color: '#142A39',
      fontFamily:'Work Sans',
      fontWeight: "normal",
      fontSize: "16px",
      lineHeight: "20px",
      letterSpacing: "-0.2px",
    },
  }); 


// WEBPACK FOOTER //
// ./src/views/components/Modal/AlertStyles.js